export default "__VITE_ASSET__DtJptxhc__";